// La tool silenciosa `finalizar_borrador_de_video` ("Pasar a 1080p") — ADR-2026-09-27-borrador-480p-y-pasar-a-1080p.
// Cobra créditos, así que el permiso no lo declara el modelo: `confirmado: true` vale
// sólo si la persona habló DESPUÉS del aviso con el costo y lo que escribió es un sí
// (`confirmacionVerificable`, como `correr_flujo` y la tienda). Puro salvo por `deps`.
import { borradorDe, borradorVigente, creditosDePasarA1080p } from '../lib/resolucionVideo';
import type { ResultadoDelFinal } from '../lib/videoBorrador';
import { anotarAviso, consumirAviso, puedeActuar } from './confirmacionVerificable';

export const NOMBRE_PASAR_A_1080P = 'finalizar_borrador_de_video';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export interface DepsPasarA1080p {
  companyId: string | null;
  leerFila: (videoId: string) => Promise<{ datos_generacion: unknown } | null>;
  finalizar: (videoId: string) => Promise<ResultadoDelFinal>;
}

/** El turno y el último mensaje de la PERSONA, para la confirmación verificable. */
export interface ContextoDeConfirmacion {
  turno: number | null;
  ultimoMensaje?: string;
}

export async function resolverPasarA1080p(
  input: unknown,
  deps: DepsPasarA1080p,
  ctx: ContextoDeConfirmacion,
): Promise<{ texto: string }> {
  const p = (input ?? {}) as { video_id?: unknown; confirmado?: unknown };
  if (typeof p.video_id !== 'string' || !UUID.test(p.video_id)) {
    return {
      texto: 'Falta `video_id` (el id del video generado, el que devolvió generate_video o show_recent_media).',
    };
  }
  if (!deps.companyId) return { texto: 'Todavía estoy cargando la cuenta. Probá de nuevo.' };
  const fila = await deps.leerFila(p.video_id);
  if (!fila) return { texto: 'No encontré ese video en esta cuenta.' };
  if (!borradorVigente(fila.datos_generacion)) {
    return {
      texto:
        'Ese video no es un borrador vigente: sólo los videos Profesional en 480p de los últimos 7 días, que todavía no se pasaron a 1080p, se pueden pasar.',
    };
  }
  const segundos = borradorDe(fila.datos_generacion)?.segundos ?? 0;
  const creditos = creditosDePasarA1080p(segundos);
  if (
    !puedeActuar({
      accion: NOMBRE_PASAR_A_1080P,
      clave: p.video_id,
      confirmado: p.confirmado === true,
      turno: ctx.turno,
      ultimoMensaje: ctx.ultimoMensaje,
    })
  ) {
    anotarAviso(NOMBRE_PASAR_A_1080P, p.video_id, ctx.turno);
    return {
      texto: `NO LO PASÉ TODAVÍA. Pasarlo a 1080p cuesta ${creditos} créditos (${segundos} s × 5 cr/s) y sale la misma toma. Decíselo al usuario y, si en su próximo mensaje dice que sí, volvé a llamarme con confirmado: true.`,
    };
  }
  consumirAviso(NOMBRE_PASAR_A_1080P);
  const r = await deps.finalizar(p.video_id);
  if (!r.ok) return { texto: `No se pudo pasar a 1080p: ${r.mensaje}` };
  return {
    texto: `Listo: el video en 1080p es video_id=${r.videoId ?? '?'} (ya está en Creaciones y en el lienzo). Se cobraron ${creditos} créditos.`,
  };
}
